import React, { useState, useContext, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import useVehiclesTableQuery from "./useVehiclesTableQuery.js";
import Button from "components/CustomButtons/Button.js";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import UserService from "services/UserService";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import { deleteVehicle } from "services/ConfigServices";
//import "react-table/react-table.css";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import { withStyles } from "@mui/styles";
// @mui/icons-material
import Edit from "@mui/icons-material/Edit";
import Tooltip from '@mui/material/Tooltip';
import styled from "styled-components";
import ReactLoading from "react-loading";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'assets/css/customNotifications.css';
import { vehiclespagetext } from "variables/vehicles";
import { statusData, motorData } from "variables/lists/vehicles";
import VehicleDialog from "./VehicleDialog.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import {
  DateInput,
} from "components/Input/Index.js";


const useStyles = makeStyles(styles);
const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles2 = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: '16px',
    },
  },
}));
const LinearIndeterminate = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LinearProgress />
    </div>
  );
};

const LoadingDiv = styled.div`
height: 20vh;
width: 20vw;
display: flex;
flex-wrap: nowrap;
align-content: center;
justify-content: center;
padding-top: 10vh;
`;
const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const ExpandableComponent = props => {
  const { data } = props;
  const classes = useStyles2();
  const SubTabs = () => {
    return (
      <>
        <div>
          <ExpandableElement>
            <ElementTitle>{vehiclespagetext.description} : </ElementTitle>
            <ElementData>{data.parameters?.description}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{vehiclespagetext.datebegin} : </ElementTitle>
            <ElementData>{data.parameters.datebegin && moment(data.parameters.datebegin).isValid()
              ? moment(data.parameters.datebegin).format("DD/MM/YYYY")
              : ""}
            </ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{vehiclespagetext.dateend} : </ElementTitle>
            <ElementData>{data.parameters.dateend && moment(data.parameters.dateend).isValid()
              ? moment(data.parameters.dateend).format("DD/MM/YYYY")
              : ""}
            </ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{vehiclespagetext.comments} : </ElementTitle>
            <ElementData>{data.parameters?.comments}</ElementData>
          </ExpandableElement>
        </div>

      </>
    );
  };
  return (
    <Container>
      <ExpandableContainer>
        <div>
          <SubTabs />
        </div>
      </ExpandableContainer>
    </Container>
  );
};

const RTVehicles = () => {
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { groupInfoListById, setPage } = advancedSearchContext;
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const vehiclesadmin = permis.includes("vehicles_admin");
  const [open, setOpen] = useState(false);
  const { gridState, refreshTable, setSelectedVehicles, 
    setLoading, selectedVehicles, vehiclesdata,
    graphdatebegin, setGraphdatebegin,
    graphdateend, setGraphdateend,
    chart1, chart2 } = useVehiclesTableQuery();
  const [row, setRow] = useState();
  const [rowClicked, setRowClicked] = useState();
  const [currentVehicle, setCurrentVehicle] = useState('');

  // console.log(filtereditemwithdata);
  useEffect(() => {
    setPage('vehicles');
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  // console.log(chart1);
  let dataVehicles = gridState.data;

  const classes = useStyles();

  const columns = [
    {
      name: vehiclespagetext.registration,
      selector: (row) => row.registration,
      sortable: true,
      width: "10rem",
      cell: (row) => row.registration
    },
    // {
    //   name: vehiclespagetext.key,
    //   selector: row => row.parameters.key,
    //   key: "key",
    //   sortable: true,
    //   //width: "8rem",
    // },
    {
      name: vehiclespagetext.name,
      selector: (row) => row.parameters.name,
      sortable: true,
      cell: (row) => row.parameters.name
      // width: "8rem",
    },
    {
      name: vehiclespagetext.brand,
      selector: (row) => row.parameters.brand,
      sortable: true,
      cell: (row) => row.parameters.brand
      // width: "8rem",
    },
    {
      name: vehiclespagetext.model,
      selector: (row) => row.parameters.model,
      sortable: true,
      cell: (row) => row.parameters.model
      // width: "8rem",
    },
    {
      name: vehiclespagetext.motor,
      selector: (row) => row.parameters.motor,
      sortable: true,
      //width: "12rem",
      // maxWidth: "12rem",
      cell: (row) => row.parameters.motor ? motorData.find((x) => x.id == row.parameters.motor).name : ''
    },
    {
      name: vehiclespagetext.status,
      selector: (row) => row.parameters.status,
      sortable: true,
      // width: "12rem",
      // maxWidth: "12rem",
      cell: (row) => row.parameters.status ?
        <div style={{ color: statusData.find((x) => x.id == row.parameters.status).color, fontWeight: "bold" }}>
          {statusData.find((x) => x.id == row.parameters.status).name}
        </div> : <></>
    },
    {
      name: vehiclespagetext.groups,
      selector: (row) => row.idgroup,
      sortable: true,
      cell: (row) => (
        <GroupCell>
          <div>{groupInfoListById["" + row.idgroup]}</div>
        </GroupCell>
      ),
      width: "8rem",
    },
    {
      name: vehiclespagetext.km,
      selector: (row) => row.km,
      sortable: true,
      cell: (row) => row.km ? new Intl.NumberFormat('fr-FR').format(row.km) : '',
      //width: "8rem",
    },
    {
      name: vehiclespagetext.cost,
      selector: (row) => row.cost,
      sortable: true,
      cell: (row) => row.cost ? new Intl.NumberFormat('fr-FR').format(row.cost) : '',
      //width: "8rem",
    },
    {
      name: vehiclespagetext.co2,
      selector: (row) => row.co2,
      sortable: true,
      cell: (row) => row.co2 ? new Intl.NumberFormat('fr-FR').format(row.co2) : '',
      //width: "8rem",
    },
    {
      name: vehiclespagetext.time,
      selector: (row) => row.time,
      sortable: true,
      cell: (row) => row.time ? new Intl.NumberFormat('fr-FR').format(row.time) : '',
      //width: "8rem",
    },
    {
      name: vehiclespagetext.costkm,
      selector: (row) => row.costkm,
      sortable: true,
      cell: (row) => row.costkm ? new Intl.NumberFormat('fr-FR').format(row.costkm) : '',
      //width: "8rem",
    },
    {
      name: "",
      sortable: false,
      width: "7rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            {vehiclesadmin && (
              <>
                <Tooltip title="Editer le véhicule">
                  <Button
                    color={"success"}
                    className={classes.actionButton}
                    onClick={editVehicle(row)}
                  >
                    <Edit className={classes.icon} />
                  </Button>
                </Tooltip>
                <CustomDeleteButton
                  deleteTitle={"Suppression du véhicule"}
                  deleteSubTitle={
                    "Êtes-vous sûr de vouloir supprimer le véhicule ?"
                  }
                  handleSupprimer={deleteVehicleRow(row)}
                /></>
            )}
          </div>
        </>
      ),
    },
  ];

  const deleteVehicleRow = (row) => async () => {
    axios
      .delete(
        deleteVehicle(row.id),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then(() => {
        refreshTable();
      })
      .catch(() => { });
  };

  const editVehicle = (row) => async () => {
    let obj = dataVehicles.find((o) => o.id === row.id);
    setCurrentVehicle(obj);
    handleClickOpen();
  };

  const handleSelectedRowsChange = (selection) => {
    setSelectedVehicles(selection.selectedRows);
  };

  const handleGraphdatebeginChange = (event) => {
    let newdatebegin = event.target.value;
    if (moment(newdatebegin).isAfter(moment(graphdateend)))
      setGraphdateend(newdatebegin);
    setGraphdatebegin(newdatebegin);
  };
  const handleGraphdateendChange = (event) => {
    let newdateend = event.target.value;
    if (moment(newdateend).isBefore(moment(graphdatebegin)))
      setGraphdatebegin(newdateend);
    setGraphdateend(newdateend);
  };


  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={3} lg={3}>
              <div>
                <DateInput
                  inputTitle={vehiclespagetext.graphdatebegin}
                  dateInput={graphdatebegin}
                  handleDateInputChange={handleGraphdatebeginChange}
                />
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={3} lg={3}>
              <div>
                <DateInput
                  inputTitle={vehiclespagetext.graphdateend}
                  dateInput={graphdateend}
                  handleDateInputChange={handleGraphdateendChange}
                />
              </div>
            </GridItem>
          </GridContainer>
        </GridItem>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={4} lg={4}>
              {chart1}
            </GridItem>
            <GridItem xs={12} sm={12} md={8} lg={8}>
              {chart2}
            </GridItem>
            {/* <GridItem xs={12} sm={12} md={4} lg={4}>
              {chart3}
            </GridItem>
            <GridItem xs={12} sm={12} md={8} lg={8}>
              {chart4}
            </GridItem> */}
          </GridContainer>
        </GridItem>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <div style={{ paddingTop: 10 }}>
            <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
              //title="Tableau d'alertes"
              noDataComponent={<NoData>{vehiclespagetext.tablenodata}</NoData>}
              noHeader={true}
              columns={columns}
              persistTableHead
              pagination
              subHeader
              selectableRows={true}
              onSelectedRowsChange={handleSelectedRowsChange}
              expandOnRowClicked
              expandableRows
              expandableRowDisabled={(row) => row.disabled}
              expandableRowsComponent={ExpandableComponent}
              paginationComponentOptions={
                {
                  noRowsPerPage: false,
                  rowsPerPageText: "Lignes par page",
                  rangeSeparatorText: "sur",
                  selectAllRowsItem: false,
                  selectAllRowsItemText: "Selectionner toutes les lignes"
                }
              }
              progressPending={gridState.loading}
              progressComponent={<div><LoadingDiv><ReactLoading
                type={"bars"}
                color={"#91c241"}
                height={"10%"}
                width={"10%"}
              /></LoadingDiv></div>}
              {...gridState}
            ></DataTable>
            <Dialog
              onClose={handleClose}
              aria-labelledby="edituser-dialog-title"
              fullWidth="true"
              maxWidth="md"
              open={open}
            >
              <CustomDialogTitle id="addMarket-dialog-title" onClose={handleClose}>
                Edition d'un véhicule
              </CustomDialogTitle>
              <DialogContent dividers>
                <VehicleDialog
                  currentVehicle={currentVehicle}
                  rowClicked={rowClicked}
                  closeModal={handleClose}
                  refetch={refreshTable}
                  setLoading={setLoading}
                />
              </DialogContent>
              <DialogActions />
            </Dialog>
            <NotificationContainer />
          </div>
        </GridItem>
      </GridContainer>

    </>
  );
};

export default RTVehicles;
